module.exports = __webpack_public_path__ + "media/images/lb/438-7bc77600d817106de9909a1b7f93fe32.svg";